import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

const initSwiper = () =>
{
  const currentPageNewsList = document.querySelector('.nl-promo');
  if(!currentPageNewsList)
  {
    return;
  }

  const sliderDiv = document.querySelector('.vertical-slider');

  const swiper = new Swiper('.vertical-slider',
      {
        modules: [Autoplay],
        slideClass: 'vertical-slider__slide',
        wrapperClass: 'vertical-slider-wrapper',
        direction: 'vertical',
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        speed: 5000,
      });


  const adjustSliderSize = () =>
  {
    sliderDiv.style.maxHeight = `${document.querySelector('.nl-promo').offsetHeight}px`;
  };

  window.addEventListener('resize', adjustSliderSize);

};

export { initSwiper };
